import { ViewDatesQuery } from '../../../../../generated/graphql.generated';

export type RemarkSeverity = 'info' | 'success' | 'warn' | 'error';

export interface DateRemark {
    /** Stable id (date + index) so multiple remarks on one date can be
     *  edited/deleted individually. */
    id: string;
    date: string;
    text: string;
    severity: RemarkSeverity;
}

export const dispatchCalendarRemarksDialogInitialState = {
    isOpen: false as boolean,
    viewDates: [] as NonNullable<ViewDatesQuery['viewDates']>,
    pendingRemarks: [] as DateRemark[],
    /** Dates with unsaved local changes — kept when view dates reload so
     *  additions/edits/deletes aren't clobbered by the server response. */
    dirtyDates: [] as string[],
    /** Remark currently loaded into the edit form; the Add button updates
     *  this remark instead of appending when set. */
    editingRemarkId: null as string | null,
    selectedDates: null as string[] | null,
    remarkText: '' as string,
    remarkSeverity: 'info' as RemarkSeverity,
    loadingViewDates: false as boolean,
    saving: false as boolean,
};

export type DispatchCalendarRemarksDialogState = typeof dispatchCalendarRemarksDialogInitialState;
